module.exports = __webpack_public_path__ + "static/media/unlimited-orders-square.a4a07907.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upgradeReason/unlimited-orders-square.svg
// module id = 1515
// module chunks = 0